import React, { useEffect, useState, Suspense, useContext, useCallback, } from "react";
import { ShowFeedback } from "../Dashboard/SendUsFeedback/Services/SendUsFeedbackService";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { TostMsg } from "../../../App";
const Showcase = () => {
  const [loader, setLoading] = useState(false);
  const [feedbackDataList, setFeedbackDataList] = useState([]);
  const toster = useContext(TostMsg);
  let userDetails //= JSON.parse(localStorage.getItem("User") || '');
  const defaultImage = "/images/placeholder_profile.png";
  useEffect(() => {
    GetFeedback();
  }, [])
  async function GetFeedback() {
    setLoading(true)
    const body = {
      loggedInEmpId: userDetails?.EmpId
    };
    try {
      let response = await ShowFeedback(body);
      setFeedbackDataList(response?.Data);
      setLoading(false);
    } catch (error) {
      toster.current.error(ERROR_LIST?.SendUsFeedBack);
      setLoading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, [])

  const Redirect = () => {
    window.open('https://orggenie.com/support', '_blank');
  }

  return (
    <>
      <div className="container-fluid   position-relation">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">
                Empowering Teams. Simplifying HR
              </h2>
              <p className="text-black mb-0">
                <strong>
                  OrgGenie is the all-in-one platform built to streamline HR processes, enhance employee experiences, and drive organizational growth.
                </strong>                </p>
            </div>

          </div>
        </div>
        <div className="row">
          <div className="about-orggenie">
            <div className="card row-gap50">
              <div className="row align-items-center justify-content-center">
                <div className="col-md-4">
                  <div className="heading-text">
                    <h1>One Platform. Every Organization’s Need.</h1>
                    <p>From onboarding to training, surveys to timesheets, service tickets to appraisals — OrgGenie brings everything into one unified workspace. Powerful tools for today, and even more coming soon.
                     
</p>
                    <div className="buttons">
                      <a href="https://www.orggenie.com" target="_blank" className="first">Visit OrgGenie.com</a>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="image">
                    <img src="images/org-img/about-org/1.png" />
                  </div>
                </div>
              </div>

              <div className="row align-items-center justify-content-center">
                <div className="col-md-10">
                  <div className="title-head">
                    <h4>HR. Work. Growth. All Covered.</h4>
                    <p>All-in-One. Built to Grow.</p>
                  </div>
                </div>
                <div className="col-md-10">
                  <div className="row" style={{ rowGap: "20px" }}>
                    <div className="col-md-3">
                      <div className="feature-content">
                        <img src="images/org-img/about-org/employee-lifecycle.png" />
                        <h4>Employee Lifecycle</h4>
                        <p>Seamless onboarding, exits, and complete employee records in one place.</p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="feature-content">
                        <img src="images/org-img/about-org/smart-directory-profile.png" />
                        <h4>Smart Directory & Profiles</h4>
                        <p>Find, follow, and manage employee profiles with intelligent search capabilities.</p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="feature-content">
                        <img src="images/org-img/about-org/wfh-management.png" />
                        <h4>Leave & WFH Management</h4>
                        <p>Apply, approve, and track leaves and WFH for self or team.</p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="feature-content">
                        < img src="images/org-img/about-org/flexible-calendar.png" />
                        <h4>Flexibility Calendar</h4>
                        <p>Visual calendar view of leaves, holidays, WFHs across the organization.</p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="feature-content">
                        < img src="images/org-img/about-org/awards and recognition.png" />
                        <h4>Rewards & Recognition</h4>
                        <p>Send kudos, celebrate milestones, and manage awards that boost morale.</p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="feature-content">
                        < img src="images/org-img/about-org/whistleblower-policy.png" />
                        <h4>Whistleblowing & Policies</h4>
                        <p>Anonymous reporting and easy access to company policies and updates.</p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="feature-content">
                        < img src="images/org-img/about-org/Social & Internal Network.png" />
                        <h4>Social & Internal Network</h4>
                        <p>Engage via posts, pictures, comments, and private company social feed.</p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="feature-content">
                        < img src="images/org-img/about-org/communication & collaboration.png" />
                        <h4>Communication & Collaboration</h4>
                        <p>One-on-one chats, group discussions, polls, and corporate broadcasts made easy.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row align-items-center justify-content-center">
                <div className="col-md-5">
                  <img src="images/org-img/about-org/2.png" />
                </div>
                <div className="col-md-5">
                  <div className="third-sectioninfo">
                    <div className="row ps-5 rowgap50">
                      <div className="col-md-6">
                        <div className="list-content">
                          < img src="images/org-img/about-org/service-desk.png" />
                          <h4>Service Desk & Approvals</h4>
                          <p>Raise cases, add observers, track SLAs and manage approvals effortlessly.</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="list-content">
                          < img src="images/org-img/about-org/payroll.png" />
                          <h4>Payroll & Benefits</h4>
                          <p>Manage payroll, tax declarations, and employee benefits with zero friction.</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="list-content">
                          < img src="images/org-img/about-org/referral.png" />
                          <h4>Hiring & Referrals</h4>
                          <p>Track applicants, manage referrals, and oversee recruitment pipelines efficiently.</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="list-content">
                          < img src="images/org-img/about-org/training.png" />
                          <h4>Training & Productivity</h4>
                          <p>Enable learning, manage projects, tasks, timesheets, and track reminders.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row align-items-center justify-content-center">
                <div className="col-md-10">
                  <div className="refer-us-content">
                    <img src="images/org-img/leave/popup-backimg.png" className="sidebg" />
                    <img src="http://devbox.bizbrolly.com:8080/html/orggenie-landingpg/assets/images/icon-free-trial.png" />
                    <h2>Refer OrgGenie</h2>
                    <p>Help others build smarter workplaces — and earn rewards for it!
                      Know a company that needs better HR? Refer them to OrgGenie and be the reason their people operations get smarter, simpler, and stronger. Earn credits for every successful subscription.</p>
                    <button className="action-btn" onClick={() => Redirect()}>Let’s Refer</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Showcase;